import { useContext } from 'react';

import NewOfferingTypeData from './NewOfferingTypeData';

import { OfferingTypesStateContext } from '../../offeringTypes/OfferingTypesContextProvider';

const useNewOfferingTypeData = () => {
  const [offeringTypeState, setOfferingTypeState] = useContext(OfferingTypesStateContext);

  const getOfferingTypesForClubRegistration = (orgUnitId, isOrganizationRegistration) => {
    return NewOfferingTypeData.getOfferingTypesForClubRegistration(orgUnitId, isOrganizationRegistration, offeringTypeState, setOfferingTypeState);    
  };

  return {
    offeringTypeState,
    setOfferingTypeState,
    getOfferingTypesForClubRegistration
  };
};

export default useNewOfferingTypeData;